import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetManagementService } from 'src/app/services/asset-management.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AuthorService } from 'src/app/services/author.service';
import { ValidationService } from 'src/app/services/validation.service';
import { FileService } from 'src/app/services/file.service';
import { AlertController } from '@ionic/angular';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { VideoAssetWizardComponent } from '../video-asset-wizard.component';
import { VideoSceneAssetRelation } from 'src/app/models/scene-asset-relations/videoSceneAssetRelation';
import { ImageSceneAssetRelation } from 'src/app/models/scene-asset-relations/imageSceneAssetRelation';

@Component({
  selector: 'app-video-details',
  templateUrl: './video-details.component.html',
  styleUrls: ['./video-details.component.scss'],
})
export class VideoDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;
  @Input('isFromMediaManagementPage') isFromMediaManagementPage: boolean = false;

  public videoFromMediaManagementPage: boolean = false;
  public oldAssetIDToCopy: number = -1;
  public videoSearchTerm: string;
  public searchNotFound: boolean = false;
  public keepAspectRatio:boolean = true;
  public previewMediaAsset:boolean = false;
  public videoSceneAssetRelation: VideoSceneAssetRelation;
  
  constructor(
    public authorService: AuthorService,
    public validationService: ValidationService,
    public assetTypeService: AssetTypeService,
    public assetManagementService: AssetManagementService,
    public fileService: FileService,
    public alertController: AlertController,
    public deepCopyService: DeepCopyService,
  ) { }

  ngOnInit() {
    this.videoSceneAssetRelation = this.assetInScene.sceneAssetRelation as VideoSceneAssetRelation;
  }    

  async selectFile() {
    let input = document.querySelector('#file-input');

    const alert = await this.alertController.create({
      header: 'Choose Media',
      message: 'You can browse for a file on your computer or select a file from the media management page.',
      cssClass: 'leave-alert quizard-alert',
      buttons: [{
        text: 'Add ' + this.assetType + ' from media management page',
        cssClass: '',
        handler: () => {
          this.currentStepInfo.addFromMediaManagementPage = true;
          this.oldAssetIDToCopy = this.currentStepInfo.uploadProperties.assetIDToCopy;
        }
      }, {
        text: 'Upload from computer',
        cssClass: '',
        handler:  () => {
          if (input) {
            input.click();
          }
        }
      }
      ]
    });
    await alert.present();
  }

  getAsset() {
    return this.authorService.selectedAsset.sceneAssetRelation as ImageSceneAssetRelation;
  }

  getVideoAsset(): MediaAsset {
    return this.assetInScene.baseAsset as MediaAsset;
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  validateBorderValue(event, asset: AssetInScene, minValue: number, maxValue: number) {
    var mediaSceneAssetRelation = asset.sceneAssetRelation as ImageSceneAssetRelation;
    var value: number = +event.target.value;
    value = this.validationService.validateMaxValue(value, maxValue);
    value = this.validationService.validateMinValue(value, minValue);
    mediaSceneAssetRelation.borderSize = value;
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var videoSettingsModal = document.getElementById('add-media-object-modal');
    videoSettingsModal.style.opacity = opacity;
  }

  updateXScale(event, asset) {
    asset.sceneAssetRelation.xScale = String(event.detail.value);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  updateScaleChanged(event, asset) {
    this.updateScale(event.detail.value, asset)
  }

  updateScale(xScale, asset){
    asset.sceneAssetRelation.xScale = String(xScale);    
    asset.sceneAssetRelation.yScale = Number(xScale) * asset.sceneAssetRelation.aspectRatioConstant;
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  updateYScale(event, asset) {
    asset.sceneAssetRelation.yScale = String(event.detail.value);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }


  videoAspectRatio() {
    this.keepAspectRatio = !this.keepAspectRatio;
    this.authorService.updateMediaAssetScale(this.assetInScene);
  }

  videoCompressed() {
    this.currentStepInfo.uploadProperties.isCompressed = !this.currentStepInfo.uploadProperties.isCompressed; 
  }

  previewMedia(){
    this.previewMediaAsset = !this.previewMediaAsset;
  }

  onMediaAssetLoad(event) {
    let videoSceneAssetRelation = this.assetInScene.sceneAssetRelation as VideoSceneAssetRelation;
    let videoWidth: number = event.target.videoWidth;
    let videoHeight: number = event.target.videoHeight;
    videoSceneAssetRelation.aspectRatioConstant = videoWidth == 0 ? videoHeight : (videoHeight / videoWidth);

    if (videoSceneAssetRelation.keepAspectRatio === true) {
      this.authorService.updateMediaAssetScale(this.assetInScene);
    }
  }

  validateBorderColour(event, assetInScene: AssetInScene) {
    var mediaAsset = this.getAsset();
    if (mediaAsset.borderColour.trim().length == 0) {
      mediaAsset.borderColour = "#FFFFFF";
    }
  }

}
